export const basicDetail =
[
 
  {
    name:"startDate",
     "rule": {
        "required": true
      },
    label:"Start Date",
    type:"date"
  },
  {
    name:"startTime",
     "rule": {
        "required": true
      },
    label:"Hour Start",
    type:"dropdown"
  },
  {
    name:"endDate",
     "rule": {
        "required": true
      },
    label:"End Date",
    type:"date"
  },
  {
    name:"endTime",
     "rule": {
        "required": true
      },
    label:"Hour End",
    type:"dropdown"
  },{
    name:"locationId",
     "rule": {
        "required": true
      },
    label:"Location",
    type:"dropdown"
  },
]

export const statusDD =
[
  { id:1, name:"Active"},
  { id:0, name:"Inactive"}
]
export const typeDD =
[
  { id:1, name:"Flat"},
  { id:2, name:"Percentage"}
]
export const editMode =
  [
    {
      name:"modTime",
      disabled:true,
       "rule": {
          "required": false
        },
      label:"Mod Time",
      type:"text"
    },
    {
      name:"modBy",
      disabled:true,
       "rule": {
          "required": false
        },
      label:"Mod By",
      type:"text"
    }
  ]